import axios from "axios"
import { CONST_API_RECRUITMENT_DEMANDES_EMBAUCHE_LISTING_ENDPOINT } from "../../../../../endpoints"
import { IGetDemandesEmbaucheListingRequestModel } from "./_models"

export function getDemandesEmbaucheListing() {
     return axios.get<IGetDemandesEmbaucheListingRequestModel[]>(CONST_API_RECRUITMENT_DEMANDES_EMBAUCHE_LISTING_ENDPOINT)
}
